import Container from "components/MainDetails/Container";
import List from "./List";
import Details from "./Details";

const Article = () => {
  return (
    <Container>
      <List stateName="article" />
      <Details />
    </Container>
  );
};

export default Article;
